import { ApiResult } from '../api/Shared';

// this is not actually a hook, but it's a function that could be useful for user-triggered actions
// from a hookified react component

export const postAction = ({
    setIsInProgress,
    setActionComplete,
    setErrorMessage,
    action
}: {
    setIsInProgress?: (val: boolean) => void;
    setActionComplete?: (val: boolean) => void;
    setErrorMessage?: (message: string | undefined) => void;
    action: () => Promise<ApiResult<undefined>>;
}) => {
    if (setErrorMessage) {
        setErrorMessage(undefined);
    }
    if (setIsInProgress) {
        setIsInProgress(true);
    }
    action().then(result => {
        if (setIsInProgress) {
            setIsInProgress(false);
        }
        if (!result.success && setErrorMessage) {
            setErrorMessage(`Error sending email: ${result.error}`);
        } else if (setActionComplete) {
            setActionComplete(true);
        }
    });
};



// WEBPACK FOOTER //
// ./src/hooks/postAction.ts